import './shared/styles/global.scss';
import './shared/polyfill';
import './shared/googleAnalytics';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { initializeSentry } from './features/errorLogging';
import { App } from './app';

initializeSentry();

ReactDOM.render(
  <BrowserRouter basename="/c">
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
);
